import { setHtml } from './css.js';
const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
const AGG = [['', '—'], ['sum', '합계'], ['avg', '평균'], ['count', '건수'], ['min', '최소'], ['max', '최대']];
export class SideBar {
    constructor(grid, root, L = k => (k.includes('|') ? k.slice(k.indexOf('|') + 1) : k)) {
        this.grid = grid;
        this.L = L;
        this.tab = null;
        this.strip = document.createElement('div');
        this.strip.className = 'og-sbs';
        this.strip.setAttribute('role', 'tablist');
        this.strip.setAttribute('aria-label', L('도구 패널'));
        this.panel = document.createElement('div');
        this.panel.className = 'og-sbp';
        this.panel.hidden = true;
        this.panel.setAttribute('role', 'tabpanel');
        root.classList.add('og-sb');
        root.appendChild(this.strip);
        root.appendChild(this.panel);
        this.renderStrip();
        this.strip.addEventListener('click', e => { const b = e.target.closest('[data-tab]'); if (b)
            this.toggle(b.dataset.tab); });
        this.panel.addEventListener('click', e => this.onClick(e));
        this.panel.addEventListener('change', e => this.onChange(e));
        this.panel.addEventListener('keydown', e => { if (e.key === 'Escape') {
            e.stopPropagation();
            this.close();
            this.strip.querySelector('button')?.focus();
        } });
    }
    /** 언어 바뀜 → 다시 그림 */
    setTranslate(L) { this.L = L; this.renderStrip(); this.refresh(); }
    open(tab = 'columns') { this.tab = tab; this.panel.hidden = false; this.renderStrip(); this.refresh(); }
    close() { this.tab = null; this.panel.hidden = true; this.renderStrip(); }
    toggle(tab) { if (this.tab === tab)
        this.close();
    else
        this.open(tab); }
    isOpen() { return this.tab != null; }
    destroy() { this.strip.remove(); this.panel.remove(); }
    renderStrip() {
        const t = (k, l) => `<button type="button" role="tab" data-tab="${k}" aria-selected="${this.tab === k}" class="og-sbt${this.tab === k ? ' og-on' : ''}">${esc(this.L(l))}</button>`;
        setHtml(this.strip, t('columns', 'sidebar|컬럼') + t('filters', 'sidebar|필터'));
    }
    /** 그리드가 바뀔 때마다 (열려 있을 때만) 다시 그림 — 입력 중인 칸은 건드리지 않음 */
    refresh() {
        if (!this.tab)
            return;
        if (this.panel.contains(document.activeElement) && document.activeElement.tagName === 'SELECT')
            return;
        this.panel.setAttribute('aria-label', this.L(this.tab === 'columns' ? 'sidebar|컬럼' : 'sidebar|필터'));
        setHtml(this.panel, this.tab === 'columns' ? this.columnsHtml() : this.filtersHtml());
    }
    columnsHtml() {
        const g = this.grid, cols = g.opts.columns, groups = g.getGroupBy();
        const rows = cols.map((c, i) => g.columnAccess(c) === 'hidden' ? '' : `<div class="og-sbr" data-col="${esc(c.id)}">
<label class="og-sbn"><input type="checkbox" data-a="vis"${c.hidden ? '' : ' checked'}> ${esc(c.header ?? c.id)}</label>
<span class="og-sbc"><button type="button" data-a="up" title="${esc(this.L('위로'))}"${i ? '' : ' disabled'}>↑</button><button type="button" data-a="down" title="${esc(this.L('아래로'))}"${i < cols.length - 1 ? '' : ' disabled'}>↓</button>
<select data-a="pin" aria-label="${esc(this.L('고정'))}"><option value="">${esc(this.L('고정 없음'))}</option><option value="left"${c.pinned === 'left' || c.pinned === true ? ' selected' : ''}>${esc(this.L('좌고정'))}</option><option value="right"${c.pinned === 'right' ? ' selected' : ''}>${esc(this.L('우고정'))}</option></select>
<label title="${esc(this.L('그룹'))}"><input type="checkbox" data-a="grp"${groups.includes(c.id) ? ' checked' : ''}>${esc(this.L('그룹'))}${groups.includes(c.id) ? ` ${groups.indexOf(c.id) + 1}` : ''}</label>
<select data-a="agg" aria-label="${esc(this.L('값'))}">${AGG.map(([v, l]) => `<option value="${v}"${(typeof c.summary === 'string' ? c.summary : '') === v ? ' selected' : ''}>${esc(this.L(l))}</option>`).join('')}</select></span></div>`).join('');
        return `<div class="og-sbh">${esc(this.L('sidebar|컬럼'))}</div><div class="og-sbl">${rows}</div>`;
    }
    filtersHtml() {
        const list = this.grid.getActiveFilters();
        const rows = list.map((f, i) => `<div class="og-sbf" data-i="${i}"><span>${esc(f.text)}</span>${f.kind === 'menu' || f.kind === 'row' ? `<button type="button" data-a="edit" aria-label="${esc(this.L('편집'))}">✎</button>` : ''}<button type="button" data-a="rm" aria-label="${esc(this.L('빼기'))}">×</button></div>`).join('');
        return `<div class="og-sbh">${esc(this.L('sidebar|필터'))} (${list.length})</div><div class="og-sbl">${rows || `<div class="og-sbe">${esc(this.L('걸린 필터가 없습니다'))}</div>`}</div>${list.length ? `<button type="button" data-a="clear" class="og-sbclr">${esc(this.L('모두 지우기'))}</button>` : ''}`;
    }
    colOf(e) { return e.target.closest('[data-col]')?.dataset.col; }
    onClick(e) {
        const b = e.target.closest('button[data-a]');
        if (!b)
            return;
        const g = this.grid, a = b.dataset.a;
        if (a === 'up' || a === 'down') {
            const id = this.colOf(e), cols = [...g.opts.columns], i = cols.findIndex(c => c.id === id), j = a === 'up' ? i - 1 : i + 1;
            if (i < 0 || j < 0 || j >= cols.length)
                return;
            [cols[i], cols[j]] = [cols[j], cols[i]];
            g.setColumns(cols, g.opts.headerGroups);
            g.notifyLayout();
            this.panel.querySelector(`[data-col="${CSS.escape(id)}"] [data-a="${a}"]`)?.focus();
            return;
        }
        if (a === 'clear') {
            g.clearFilters();
            this.refresh();
            return;
        }
        const i = +(e.target.closest('[data-i]')?.dataset.i ?? -1);
        const f = g.getActiveFilters()[i];
        if (!f)
            return;
        if (a === 'rm') {
            f.remove();
            this.refresh();
        }
        else if (a === 'edit' && f.col)
            g.openFilterMenu(f.col);
    }
    onChange(e) {
        const t = e.target, id = this.colOf(e);
        if (!id)
            return;
        const g = this.grid;
        switch (t.dataset.a) {
            case 'vis':
                g.setColumnVisible(id, t.checked);
                break;
            case 'pin':
                g.setColumnProperty(id, 'pinned', (t.value || undefined));
                break;
            case 'grp': {
                const cur = g.getGroupBy().filter(x => x !== id);
                g.setGroupBy(t.checked ? [...cur, id] : cur.length ? cur : null);
                break;
            }
            case 'agg':
                g.setColumnProperty(id, 'summary', (t.value || undefined));
                if (t.value && !g.opts.showFooter)
                    g.setOptions({ showFooter: true });
                break;
        }
        ;
        t.blur();
        this.refresh();
    }
}
